<template>
<div>
    <md-dialog-content>
        <p>Collaborators</p>
        <md-list class="md-double-line">
            <md-list-item v-if="owner">
                <md-avatar>
                    <img :src="owner.profile_picture" alt="Owner Profile"/>
                </md-avatar>
                <div class="md-list-text-container">
                    <span>{{owner.username}}</span>
                    <span>{{owner.email}}</span>
                    <span>Project Owner</span>
                </div>
            </md-list-item>
            <collaborator v-for="(collab, index) in project.collaborators"
                :user="collab.uid && userByUID(collab.uid) || collab"
                :collaborator="collab" 
                :collabUser="null"
                :key="collab.uid || index" 
                @removeCollaborator="removeCollaborator" 
            />
            <invite :project="project" @addCollaborator="addCollaborator"/>
        </md-list>        
    </md-dialog-content>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import CollaboratorsCollaborator from '@/components/collaborators/collaborator';
import CollaboratorsInvite from '@/components/collaborators/invite';

const Collaborators = {
    name: 'collaborators',
    props: ['project'],
    computed: {
        ...mapGetters([
            'user',
            'userByUID'
        ]),
        owner() {
            return this.user;
        }
    },
    methods: {
        addCollaborator(collab) {
            this.project.collaborators.unshift(collab);
        },
        removeCollaborator(collab) {
            const index = this.project.collaborators.findIndex((c) => {
                return c.uid === collab.uid || c.email === collab.email;
            });
            if (index > -1) {
                this.project.collaborators.splice(index, 1);
            }
        }
    },
    components: {
        collaborator: CollaboratorsCollaborator,
        invite: CollaboratorsInvite
    }
};
export default Collaborators;
</script>

<style>
.md-dialog {
    overflow-y: scroll;
}

</style>


// WEBPACK FOOTER //
// collaborators.vue?64bc06f2